import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import { getUserInfo } from '../../utils/cookiesUser';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

const mountBody = ({ ddd, telefone, tipo, id } = {}, phoneTypes) => ({
  id,
  ddd,
  telefone,
  tipo: phoneTypes.find((item) => item.key === tipo) || tipo,
});

function* customerPhonesRequest({ payload, remove }) {
  try {
    const token = yield select(getToken);
    const { customer, app } = yield select(getState);

    const { id } = getUserInfo();

    const siteId = app.getIn(['config', 'siteId']);
    const phoneTypes = app.getIn(['config', 'components', 'MyAccount', 'phoneTypes']);

    const customerId = customer.id || id;
    const body = mountBody(payload, phoneTypes);
    let method = 'get';

    if (payload) {
      method = payload.id ? 'put' : 'post';
    }

    if (remove) {
      method = 'delete';
    }

    let data = yield call(customerAPI.phones[method], customerId, token, body, siteId);

    if (method !== 'get') {
      data = yield call(customerAPI.phones.get, customerId, token, null, siteId);
    }

    yield put(Creators.customerPhonesSuccess(data));

    if (method === 'put' || method === 'post') {
      yield put(AppCreators.feedbackRequest({ open: true, message: 'Telefone salvo com sucesso', type: 'success' }));
    }
  } catch (error) {
    const formatted = formatError(error);
    yield put(Creators.customerPhonesFailed(formatted));
    yield put(AppCreators.feedbackRequest({ open: true, message: formatted.message }));
  }
}

export default function* watch() {
  yield takeLatest(Types.CUSTOMER_PHONES_REQUEST, customerPhonesRequest);
}
